import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";
import { AdminViewAllOrders } from "../utils/Api/ApiCalls";
import { Link } from "react-router-dom";
import { useRecoilState } from "recoil";
import { OrderDetailState } from "../Services/RecoilAtoms";

const OrderList1 = () => {
  const [date, setDate] = useState(new Date());
  const [orderData, setOrderData] = useState();
  const [order, setOrder] = useRecoilState(OrderDetailState);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const itemsPerPage = 5;

  const [searchTerm, setSearchTerm] = useState("");
  const [temp, setTemp] = useState([]);

  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);

  // Simulate fetching items from another resources.
  // (This could be items from props; or items loaded in a local state
  // from an API endpoint with useEffect and useState)
  const endOffset = itemOffset + itemsPerPage;
  let currentItems = orderData?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(orderData?.length / itemsPerPage);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % orderData.length;
    setItemOffset(newOffset);
  };

  const fetchingOrders = async () => {
    try {
      const response = await AdminViewAllOrders();
      setOrderData(response?.data);
      console.log(response?.data);
    } catch (err) {
    Swal.fire({ icon: "error", title: "Error", text: err?.response?.data?.message || err?.message || "An error occurred" });
    return err;
  }
  };

  useEffect(() => {
    fetchingOrders();
  }, []);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const onSearch = () => {
    let data = temp.filter(
      (item, i) =>
        item["product_data"].productTitle.includes(searchTerm) ||
        item["product_data"].category.includes(searchTerm)
    );

    setOrderData(data);
  };

  return (
    <>
      <section class="content-main">
        <div class="content-header">
          <div>
            <h2 class="content-title card-title">Order List</h2>
            <p>Collections of published orders.</p>
          </div>
          <div>
            {/* <input
              type="text"
              placeholder="Search order ID"
              class="form-control bg-white"
            /> */}
          </div>
          <div>
            <Link to="/delivery" class="btn btn-primary">
              <i class="text-muted material-icons md-post_add"></i>Deliveries
            </Link>
          </div>
        </div>
        <div class="card mb-4">
          <header class="card-header">
            <div class="row gx-3">
              <div class="col-lg-4 col-md-6 me-auto">
                <input
                  type="text"
                  placeholder="Search by product title, category."
                  class="form-control"
                  value={searchTerm}
                  onChange={handleSearchChange}
                  onKeyUp={onSearch}
                />
              </div>
              {/* <div class="col-lg-2 col-6 col-md-3">
                <select class="form-select">
                  <option>Status</option>
                  <option>Active</option>
                  <option>Disabled</option>
                  <option>Show all</option>
                </select>
              </div> */}
              <div class="col-lg-2 col-6 col-md-3">
                {/* <select class="form-select" name="selection" onChange={onSelectionChange}>
                <option value="all">All</option>
                <option value="1">Show 5</option>
                <option value="5">Show 5</option>
                <option value="10">Show 10</option>
                <option value="20">Show 20</option>
                <option value="30">Show 30</option>
                <option value="40">Show 40</option>
              </select> */}
              </div>
            </div>
          </header>

          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>Order ID</th>
                    <th scope="col">Customer Name</th>
                    <th scope="col">Customer Email</th>
                    {/* <th scope="col">Image</th> */}
                    <th scope="col">Total</th>
                    <th scope="col">Date</th>
                    <th scope="col">Shipping Type</th>
                    <th scope="col">Status</th>
                    <th scope="col" class="text-end">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems?.length > 0 ? (
                    <>
                      {currentItems &&
                        currentItems.map((props, i) => (
                          <tr key={props.id}>
                            <td>{props.orderId}</td>
                            <td>{props.customerName}</td>
                            <td>{props.customerEmail}</td>
                            {/* <td>
                            {/* <b>Marvin McKinney</b>
                            <b>{props["product_data"]?.productTitle}</b>
                            {/* <b>{props["user"]?.email}</b> 
                          </td> */}
                            {/* <td>
                            {" "}
                            <img
                              style={{ width: "40px", height: "30px" }}
                              // src={`http://localhost:7045/uploads/${props["product_data"]?.productImages[0].img}`}
                              src={`https://backend.argone.ng/uploads/${props["product_data"]?.productImages[0].img}`}
                              alt="#"
                            />
                          </td> */}
                            <td>₦{props?.amount?.toLocaleString()}</td>
                            {/* <td>
                            <span class="badge rounded-pill alert-success">
                              Completed
                            </span>
                          </td> */}
                            <td>
                              {new Date(props?.createdDate).toDateString()}
                            </td>
                            <td>
                              {props?.shippingType === 0
                                ? "Pick up"
                                : "Delivery"}
                            </td>
                            <td>{props?.status}</td>
                            <td class="text-end">
                              {/* <a href="#" class="btn btn-md rounded font-sm">
                                    Detail
                                  </a> */}
                              {/* <div class="dropdown">
                                <a
                                  href="#"
                                  data-bs-toggle="dropdown"
                                  class="btn btn-light rounded btn-sm font-sm"
                                >
                                  <i class="material-icons md-more_horiz"></i>
                                </a>
                                <div class="dropdown-menu">
                                  <a class="dropdown-item">
                                    <Link
                                      to={`/order/details/${props.orderId}`}
                                    >
                                      View details
                                    </Link>
                                  </a>

                                  
                                  <a class="dropdown-item text-danger" href="#">
                                    Delete
                                  </a>
                                </div>
                              </div> */}
                              <Link
                                      // onClick={() => {
                                      //   setOrder(props);
                                      // }}
                                      to={`/order/details/${props.orderId}`}
                                    >
                                      View details
                                    </Link>
                            </td>
                          </tr>
                        ))}
                    </>
                  ) : (
                    <div>No order Found</div>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* <div class="pagination-area mt-15 mb-50">
          <nav aria-label="Page navigation example">
            <ul class="pagination justify-content-start">
              <li class="page-item active">
                <a class="page-link" href="#">
                  01
                </a>
              </li>
              <li class="page-item">
                <a class="page-link" href="#">
                  02
                </a>
              </li>
              <li class="page-item">
                <a class="page-link" href="#">
                  03
                </a>
              </li>
              <li class="page-item">
                <a class="page-link dot" href="#">
                  ...
                </a>
              </li>
              <li class="page-item">
                <a class="page-link" href="#">
                  16
                </a>
              </li>
              <li class="page-item">
                <a class="page-link" href="#">
                  <i class="material-icons md-chevron_right"></i>
                </a>
              </li>
            </ul>
          </nav>
        </div> */}
        <div class="pagination-area mt-30 mb-50">
          <nav aria-label="Page navigation example">
            <ReactPaginate
              nextLabel="Next"
              onPageChange={handlePageClick}
              pageRangeDisplayed={3}
              marginPagesDisplayed={2}
              pageCount={pageCount}
              previousLabel="Previous"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link w-auto"
              nextClassName="page-item"
              nextLinkClassName="page-link w-auto"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination justify-content-start"
              activeClassName="active"
              renderOnZeroPageCount={null}
            />
            {/* <ul class="pagination justify-content-start">
              <li class={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                <a
                  class="page-link"
                  href="#"
                  onClick={goToPreviousPage}
                  style={{ width: "auto" }}
                >
                  Previous
                </a>
              </li>
              {Array.from(
                { length: Math.ceil(productData?.length / itemsPerPage) },
                (_, i) => (
                  <li
                    class={`page-item ${i + 1 === currentPage ? "active" : ""}`}
                    key={i}
                  >
                    <a
                      class="page-link"
                      href="#"
                      onClick={() => paginate(i + 1)}
                    >
                      {i + 1}
                    </a>
                  </li>
                )
              )}
              <li
                class={`page-item ${
                  currentPage === Math.ceil(productData?.length / itemsPerPage)
                    ? "disabled"
                    : ""
                }`}
              >
                <a
                  class="page-link"
                  href="#"
                  onClick={goToNextPage}
                  style={{ width: "auto" }}
                >
                  Next
                </a>
              </li>
            </ul> */}
          </nav>
        </div>
      </section>
    </>
  );
};

export default OrderList1;
